<template>
  <div class="performance-estimate-dialog">
    <asc-dialog
      text="Performance Estimate"
      :show-dialog="showDialog"
      :width="90"
      width-is-percent
      :on-close="onCloseEstimateDialog"
    >
      <template v-if="showDialog">
        <div class="analytic-details">
          <v-row>
            <v-col v-if="!isSingleAirlineUser" cols="2">
              <asc-text-field-input
                v-model="getAirline"
                label="Airline"
                readonly
              />
            </v-col>
            <v-col cols="1">
              <asc-text-field-input
                v-model="getPlatform"
                label="Platform"
                readonly
              />
            </v-col>
            <v-col cols="2">
              <asc-text-field-input
                v-model="getPartNumbers"
                label="Part Number"
                readonly
              />
            </v-col>
            <v-col cols="1">
              <asc-text-field-input
                v-model="getFrequencyText"
                label="Frequency"
                readonly
              />
            </v-col>
            <v-col cols="6">
              <asc-text-field-input
                v-model="getLogicString"
                label="Logic String"
                readonly
              />
            </v-col>
          </v-row>
        </div>
        <asc-plotly
          :plotly-data="plotlyData"
          :look-back-run-info="{
            runId: getRunId,
            airline: airline,
            platform: platform,
            airlineIcaoCode: airlineIcaoCode,
          }"
        >
        </asc-plotly>
      </template>
    </asc-dialog>
  </div>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import AscPlotly from './AscPlotly.vue'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'

export default {
  name: 'AscSeeEstimateDialog',

  components: {
    AscDialog,
    AscPlotly,
    AscTextFieldInput,
  },

  props: {
    onCloseEstimateDialog: {
      type: Function,
      default: () => {},
    },
    plotlyData: {
      type: Object,
      default: null,
    },
    airline: {
      type: String,
      default: '',
    },
    airlineIcaoCode: {
      type: String,
      default: '',
    },
    platform: {
      type: String,
      default: '',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    alertData: {
      type: Object,
      default: () => {},
    },
    partNumbers: {
      type: String,
      default: '',
    },
    isSingleAirlineUser: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      data: {},
    }
  },

  computed: {
    getFrequencyText() {
      return `${this.alertData?.persistenceFrom} of ${this.alertData?.persistenceTo} Flights`
    },
    getLogicString() {
      return this.alertData?.expression
    },
    getAirline() {
      return this.airline
    },
    getPlatform() {
      return this.platform
    },
    getPartNumbers() {
      return this.partNumbers
    },
    getRunId() {
      return this.alertData?.runId
    },
  },

  watch: {},

  methods: {},
}
</script>

<style lang="scss">
.performance-estimate-dialog {
  .v-card__title {
    border-bottom: 1px solid $gray-200;
  }
  .analytic-details {
    padding: 16px 16px 0px 16px;
    margin-top: 16px;
    margin: 16px 0px 16px 0px;
    border: 1px solid $gray-200;
  }
  .asc-input-field--container-textfield {
    input {
      text-overflow: ellipsis;
    }
  }
}
</style>
